// extracted by mini-css-extract-plugin
export var btnContainer = "ContactBlockV2-module--btn-container--3ca19";
export var btns = "ContactBlockV2-module--btns--54fe1";
export var comparison_desktop = "ContactBlockV2-module--comparison_desktop--4cbf1";
export var comparison_table = "ContactBlockV2-module--comparison_table--42bec";
export var consultationCtaBtnV1 = "ContactBlockV2-module--consultation-cta-btn-v1--0c3dd";
export var contact_block_v2 = "ContactBlockV2-module--contact_block_v2--652c5";
export var contact_block_v2_content = "ContactBlockV2-module--contact_block_v2_content--62cd4";
export var contact_block_v2_image = "ContactBlockV2-module--contact_block_v2_image--a6ca3";
export var contact_block_v2_solutionPage = "ContactBlockV2-module--contact_block_v2_solutionPage--ad205";
export var contact_block_v2_solutionPage_content_v1 = "ContactBlockV2-module--contact_block_v2_solutionPage_content_v1--43044";
export var contact_block_v2_solutionPage_image = "ContactBlockV2-module--contact_block_v2_solutionPage_image--7d8bc";
export var container = "ContactBlockV2-module--container--004cf";
export var containerBannerV1 = "ContactBlockV2-module--container--banner-v1--c5433";
export var containerFooterBottom = "ContactBlockV2-module--container--footer-bottom--63cbb";
export var containerFooterTop = "ContactBlockV2-module--container--footer-top--51f32";
export var containerLargeL = "ContactBlockV2-module--container--large-l--3cd53";
export var containerLargeM = "ContactBlockV2-module--container--large-m--2f427";
export var containerMediumL = "ContactBlockV2-module--container--medium-l--00f06";
export var containerMediumM = "ContactBlockV2-module--container--medium-m--50d78";
export var containerMob = "ContactBlockV2-module--container--mob--a77c5";
export var containerMob1 = "ContactBlockV2-module--container--mob-1--97637";
export var containerSmallL = "ContactBlockV2-module--container--small-l--2d479";
export var containerSmallM = "ContactBlockV2-module--container--small-m--df76c";
export var containerSmallS = "ContactBlockV2-module--container--small-s--fea15";
export var containerSmallSub = "ContactBlockV2-module--container--small-sub--cfde1";
export var containerSmallXl = "ContactBlockV2-module--container--small-xl--b48b4";
export var containerV10 = "ContactBlockV2-module--container--v10--fb8fe";
export var containerV12 = "ContactBlockV2-module--container--v12--22944";
export var containerV2 = "ContactBlockV2-module--container-v2--a260c";
export var containerV3 = "ContactBlockV2-module--container-v3--2d123";
export var cursorPointer = "ContactBlockV2-module--cursor--pointer--88288";
export var dkCtaBtn = "ContactBlockV2-module--dk-cta-btn--5be3c";
export var dkCtaBtnArrow = "ContactBlockV2-module--dk-cta-btn--arrow--852e8";
export var dkCtaBtnBlack = "ContactBlockV2-module--dk-cta-btn--black--47138";
export var dkCtaBtnLarge = "ContactBlockV2-module--dk-cta-btn--large--a3542";
export var dkCtaBtnMid = "ContactBlockV2-module--dk-cta-btn--mid--deca5";
export var dkCtaBtnSm = "ContactBlockV2-module--dk-cta-btn--sm--0ddc1";
export var flex = "ContactBlockV2-module--flex--39de4";
export var flexAcC = "ContactBlockV2-module--flex-ac-c--fbfe2";
export var flexAiC = "ContactBlockV2-module--flex-ai-c--f6d80";
export var flexDirC = "ContactBlockV2-module--flex-dir-c--8a5e4";
export var flexJcC = "ContactBlockV2-module--flex-jc-c--345f3";
export var flexJcSb = "ContactBlockV2-module--flex-jc-sb--ce071";
export var flexShrinkNone = "ContactBlockV2-module--flex-shrink-none--6ea20";
export var fontPrimary = "ContactBlockV2-module--font--primary--fd7a1";
export var fontSecondary = "ContactBlockV2-module--font--secondary--8a346";
export var gap05x = "ContactBlockV2-module--gap-05x--dcbc5";
export var gap1x = "ContactBlockV2-module--gap-1x--ce651";
export var gap1xV2 = "ContactBlockV2-module--gap-1x-v2--82e97";
export var gap2x = "ContactBlockV2-module--gap-2x--a0f48";
export var gap2xV2 = "ContactBlockV2-module--gap-2x-v2--8c9e1";
export var gap2xV3 = "ContactBlockV2-module--gap-2x-v3--07316";
export var gap3x = "ContactBlockV2-module--gap-3x--dc768";
export var gap3xV2 = "ContactBlockV2-module--gap-3x-v2--4ba4d";
export var gap3xV3 = "ContactBlockV2-module--gap-3x-v3--c3adf";
export var gap3xV4 = "ContactBlockV2-module--gap-3x-v4--e19a2";
export var gap4x = "ContactBlockV2-module--gap-4x--a59bc";
export var gap4xV2 = "ContactBlockV2-module--gap-4x-v2--d5d92";
export var gap5x = "ContactBlockV2-module--gap-5x--70706";
export var gap5xV2 = "ContactBlockV2-module--gap-5x-v2--3f8cf";
export var gap5xV3 = "ContactBlockV2-module--gap-5x-v3--6d122";
export var gap5xV4 = "ContactBlockV2-module--gap-5x-v4--ff39d";
export var gap5xV5 = "ContactBlockV2-module--gap-5x-v5--a7747";
export var gap6x = "ContactBlockV2-module--gap-6x--bb9c6";
export var gap6xV2 = "ContactBlockV2-module--gap-6x-v2--93b47";
export var gap6xV3 = "ContactBlockV2-module--gap-6x-v3--20040";
export var gap7x = "ContactBlockV2-module--gap-7x--11e15";
export var gap7xV2 = "ContactBlockV2-module--gap-7x-v2--2c3cc";
export var gap7xV3 = "ContactBlockV2-module--gap-7x-v3--e9ace";
export var gap7xV4 = "ContactBlockV2-module--gap-7x-v4--eeb4c";
export var gap8x = "ContactBlockV2-module--gap-8x--7ea35";
export var gap8xV2 = "ContactBlockV2-module--gap-8x-v2--85936";
export var hideForDesktop = "ContactBlockV2-module--hide-for-desktop--92a0f";
export var hideForMobile = "ContactBlockV2-module--hide-for-mobile--228d8";
export var imgW100 = "ContactBlockV2-module--img-w-100--d38b4";
export var industryCaseStudyBtn = "ContactBlockV2-module--industry-case-study-btn--7cdb6";
export var learnMoreBtn = "ContactBlockV2-module--learn-more-btn--995bc";
export var learnMoreBtnSmall = "ContactBlockV2-module--learn-more-btn--small--5455b";
export var loadMoreBtn = "ContactBlockV2-module--load-more-btn--3fd89";
export var pointerNone = "ContactBlockV2-module--pointer-none--90fa7";
export var secondaryBtn = "ContactBlockV2-module--secondary-btn--75fd5";
export var solutionBtn = "ContactBlockV2-module--solutionBtn--9eba0";
export var table_wrapper = "ContactBlockV2-module--table_wrapper--92574";
export var tertiaryBtn = "ContactBlockV2-module--tertiary-btn--7dc71";
export var textBig = "ContactBlockV2-module--text-big--7f706";
export var textCenter = "ContactBlockV2-module--text--center--bc264";
export var textClrBlue = "ContactBlockV2-module--text-clr-blue--5421a";
export var textClrError = "ContactBlockV2-module--text-clr-error--00ce9";
export var textClrGrey = "ContactBlockV2-module--text-clr-grey--e6c95";
export var textClrGrey2 = "ContactBlockV2-module--text-clr-grey-2--8f5b3";
export var textClrGrey3 = "ContactBlockV2-module--text-clr-grey-3--2f159";
export var textClrGrey4 = "ContactBlockV2-module--text-clr-grey-4--c3ae5";
export var textClrGrey5 = "ContactBlockV2-module--text-clr-grey-5--e5484";
export var textClrNeutral400 = "ContactBlockV2-module--text-clr-neutral-400--b1cb3";
export var textClrOrange = "ContactBlockV2-module--text-clr-orange--ca645";
export var textClrPrimary = "ContactBlockV2-module--text-clr-primary--8a3e2";
export var textClrSecondary = "ContactBlockV2-module--text-clr-secondary--9911a";
export var textClrWhite = "ContactBlockV2-module--text-clr-white--c83e3";
export var textDecorNone = "ContactBlockV2-module--text-decor-none--746c8";
export var textFwBold = "ContactBlockV2-module--text-fw-bold--6280d";
export var textFwLight = "ContactBlockV2-module--text-fw-light--c0cc7";
export var textFwMedium = "ContactBlockV2-module--text-fw-medium--71f0d";
export var textFwRegular = "ContactBlockV2-module--text-fw-regular--096e9";
export var textFwStrong = "ContactBlockV2-module--text-fw-strong--b6119";
export var textH1 = "ContactBlockV2-module--text-h1--db9e2";
export var textH2 = "ContactBlockV2-module--text-h2--4e8ba";
export var textH3 = "ContactBlockV2-module--text-h3--667e9";
export var textH4 = "ContactBlockV2-module--text-h4--602ac";
export var textH5 = "ContactBlockV2-module--text-h5--231a5";
export var textH6 = "ContactBlockV2-module--text-h6--dfe80";
export var textLarge = "ContactBlockV2-module--text-large--5cb57";
export var textLlarge = "ContactBlockV2-module--text-llarge--f442c";
export var textP1 = "ContactBlockV2-module--text-p1--e1ad0";
export var textP2 = "ContactBlockV2-module--text-p2--4e79c";
export var textP2V2 = "ContactBlockV2-module--text-p2-v2--e3f2c";
export var textP3 = "ContactBlockV2-module--text-p3--a8ee3";
export var textP4 = "ContactBlockV2-module--text-p4--8bc88";
export var textSmall = "ContactBlockV2-module--text-small--28b3d";